import { render, staticRenderFns } from "./selectTag.vue?vue&type=template&id=fc8d6f12&"
import script from "./selectTag.vue?vue&type=script&lang=js&"
export * from "./selectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports